document.addEventListener("DOMContentLoaded", function() {
  const ul = document.querySelectorAll('.c-language');
  
  ul.forEach(ulElement => {
      const listItems = Array.from(ulElement.querySelectorAll('li'));

      const order = ["zh-tw", "zh-cn", "en", "ja"];

      listItems.sort((a, b) => {
          const aIso = a.getAttribute('data-iso');
          const bIso = b.getAttribute('data-iso');

          const aIndex = order.indexOf(aIso);
          const bIndex = order.indexOf(bIso);

          if (aIndex === -1 && bIndex === -1) {
              return 0;
          } else if (aIndex === -1) {
              return 1;
          } else if (bIndex === -1) {
              return -1;
          } else {
              return aIndex - bIndex;
          }
      });

      // Remove existing items
      ulElement.innerHTML = "";

      // Append sorted items
      listItems.forEach(item => ulElement.appendChild(item));
  });
});

// (() => {
//   // Select all images in the DOM
//   const images = document.querySelectorAll('img');
  
//   // Loop through each image and append the placeholder image after it
//   images.forEach(image => {
//       // Create a new img element
//       const ecImgGuard = document.createElement('img');
//       ecImgGuard.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
//       ecImgGuard.className = 'EcImgGuard';
  
//       // Append the new image after the existing image
//       image.after(ecImgGuard);
//   });
// })();